import React, { ReactNode } from 'react';

interface ButtonContainerProps {
    className?: string;
    children: ReactNode;
    marginTop?: string;
}

const ButtonContainer: React.FC<ButtonContainerProps> = ({
    className = '',
    children,
    marginTop = '48px',
}) => {
    return (
        <div
            className={`sm-button-container ${className}`}
            style={{ marginTop }}
        >
            {children}
        </div>
    );
};

export default ButtonContainer;
